import { cn } from '@lyearn/style';
import { AutocompleteRenderOptionState, SelectSize, Stack, Typography } from '@lyearn/ui';

import { FormSelectOption } from './types';

const COLOR_CONFIG = {
  selected: { icon: 'text-icon-primary', label: 'text-text-primary' },
  unselected: { icon: 'text-icon-secondary', label: 'text-text-secondary' },
} as const;

const SIZE_CONFIG = {
  large: { icon: 'w-22 h-22', label: 'body-short-01' },
  medium: { icon: 'w-20 h-20', label: 'body-short-02' },
} as const;

interface Props<T> {
  option: FormSelectOption<T>;
  size: SelectSize;
  isSelected: boolean;
}

const SelectOptionLabelRenderer = <T,>(props: Props<T>) => {
  const { option, size, isSelected } = props;
  const { Icon, label } = option;
  const sizeConfig = SIZE_CONFIG[size];
  const colorConfig = COLOR_CONFIG[isSelected ? 'selected' : 'unselected'];

  return (
    <Stack alignItems="center" className="flex-1" gapX={12}>
      {Icon ? <Icon className={cn('shrink-0', colorConfig.icon, sizeConfig.icon)} /> : null}
      <Typography
        color={colorConfig.label}
        numberOfLines={1}
        title={label}
        variant={sizeConfig.label}>
        {label}
      </Typography>
    </Stack>
  );
};

export const renderMediumOptionLabel = <T,>(
  option: FormSelectOption<T>,
  state: AutocompleteRenderOptionState,
) => <SelectOptionLabelRenderer isSelected={state.selected} option={option} size="medium" />;

export const renderLargeOptionLabel = <T,>(
  option: FormSelectOption<T>,
  state: AutocompleteRenderOptionState,
) => <SelectOptionLabelRenderer isSelected={state.selected} option={option} size="large" />;
